import { render } from "./GpaBetweenPrograms.vue?vue&type=template&id=93a0da72"
import script from "./GpaBetweenPrograms.vue?vue&type=script&lang=js"
export * from "./GpaBetweenPrograms.vue?vue&type=script&lang=js"
script.render = render

export default script